import { createSlice } from "@reduxjs/toolkit";
import { Pagination } from "../../../utils/api";
import { CargoType } from "../../cargo-types/store/slice";
import { Company } from "../../company-page/store/slice";
import { Media } from "../../documents/store/slice";
import { Route } from "../../routes/store/slice";
import { Status } from "../../statuses/store/slice";
import { User } from "../../users/store/slice";
import { VehicleType } from "../../vehicle-types/store/slice";
import { TrailerType } from "../../trailer-types/store/slice";
import { Country } from "../../countries/store/slice";

export type Driver = {
  id: number;
  first_name: string;
  last_name: string;
  phone: string;
  birth_date: string;
  document_number: string;
  country?: Country;
  document_country?: Country;
  gender: number;
  document_expiration_date: string;
  created_at: string;
  updated_at: string;
};

export type Booking = {
  id: number;
  route: Route;
  booking_status: Status | null;
  ticket_status: Status | null;
  invoice_status: Status | null;
  creator: User;
  owner: User;
  vehicle_type: VehicleType;
  trailer_type?: TrailerType;
  cargo_type?: CargoType;
  vehicle_number: string;
  trailer_number: string;
  vehicle_registration_country?: Country;
  trailer_registration_country?: Country;
  vehicle_length: number;
  vehicle_width: number;
  vehicle_weight: number;
  plug_in: boolean;
  adr: boolean;
  driver_count: 0 | 1 | 2;
  first_driver_name: string;
  first_driver_last_name: string;
  first_driver_data: string;
  second_driver_name: string;
  second_driver_last_name: string;
  second_driver_data: string;
  customer_reference: string;
  booking_reference: string;
  provider_notes: string;
  ordered_at: string;
  archived_at: string;
  deleted_at: string;
  created_at: string;
  updated_at: string;
  documents: Media[];
  departure_at: string;
  arrival_at: string;
  duration: string;
  company: Company;
  temperature: string;
  drivers: Driver[];
};

type InitialState = {
  data: Booking[];
  meta: Pagination | null;
  isLoading: boolean;

  isFiltersOpened: boolean;
  isColumnsOpened: boolean;
};

const initialState: InitialState = {
  data: [],
  meta: null,
  isLoading: false,

  isFiltersOpened: false,
  isColumnsOpened: false,
};

const bookingPageSlice = createSlice({
  name: "bookingPageSlice",
  initialState,
  reducers: {
    fetchData: (state) => {
      state.isLoading = true;
    },
    setData: (state, action) => {
      const { data, meta } = action.payload;

      state.data = data;
      state.meta = meta;
    },
    loadMore: (state) => {
      state.isLoading = true;

      if (state.meta) {
        state.meta.current_page++;
      }
    },
    addData: (state, action) => {
      const { data, meta } = action.payload;

      state.data = [...state.data, ...data];
      state.meta = meta;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setIsFiltersOpened: (state, action) => {
      state.isFiltersOpened = action.payload;
    },
    setIsColumnsOpened: (state, action) => {
      state.isColumnsOpened = action.payload;
    },
    cancel: (state, action) => {
      state.isLoading = true;
    },
    resetData: (state) => {
      state.data = [];
      state.meta = null;
      state.isLoading = false;
    },
    reset: () => initialState,
  },
});

export default bookingPageSlice;
